import { render, staticRenderFns } from "./EmSicCustomizedDiagramPieceCdpEdit.vue?vue&type=template&id=2b4b0415&"
import script from "./EmSicCustomizedDiagramPieceCdpEdit.vue?vue&type=script&lang=js&"
export * from "./EmSicCustomizedDiagramPieceCdpEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports